import { combinedRoles } from "../constants";
import { TemplateRouteAnsweredActivity } from "../types";

export const TemplateRouteAnswered = ({
  activityItem
}: {
  activityItem: TemplateRouteAnsweredActivity;
}) => {
  const { author, details } = activityItem;

  return (
    <div className="text-sm font-normal text-content-400">
      {author?.name ? (
        <p>
          by {author.name}
          {author.author_role ? ` (${combinedRoles[author.author_role]})` : ""}
        </p>
      ) : null}
      <p>
        “{details.question}”: {details.route_label} • Uses{" "}
        {details.target_template_name ?? details.template_name}
      </p>
    </div>
  );
};
